import { render, staticRenderFns } from "./FilterResult.vue?vue&type=template&id=6b72be5e&scoped=true&"
import script from "./FilterResult.vue?vue&type=script&lang=js&"
export * from "./FilterResult.vue?vue&type=script&lang=js&"
import style0 from "./FilterResult.vue?vue&type=style&index=0&id=6b72be5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b72be5e",
  null
  
)

export default component.exports